<template>
  <div class="d-flex flex-column">
    <span class="product-label">Itens consumidos c/ desconto</span>
    <div class="d-flex flex-row align-center" style="gap: 4px">
      <span :class="consumerReachedMax ? 'product-value red-consumption' : 'product-value'">{{ localeString(userSaleConsumptionAmount, 2) || '-' }}</span>
      <tooltip :disabled="!consumerReachedMax" message="Consumidor atingiu o máximo de consumo">
        <mf-icon v-if="consumerReachedMax" small color="vermelho-0" fill>warning</mf-icon>
      </tooltip>
    </div>
  </div>
</template>

<script>
import Tooltip from '@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip'

export default {
  name: 'UserConsumption',
  components: {
    Tooltip,
  },
  props: {
    userSaleConsumptionAmount: {
      type: Number,
      default: 0,
    },
    maximumPerClient: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    consumerReachedMax() {
      if (!this.maximumPerClient || this.maximumPerClient === 0) return false
      return this.userSaleConsumptionAmount >= this.maximumPerClient
    },
  },
}
</script>

<style lang="scss" scoped>
.product-label {
  font-size: 14px;
  font-weight: 400;
  color: $cinza-l30;
}

.product-value {
  color: $cinza-d10;
  font-weight: 700;
}

.red-consumption {
  color: $vermelho-0;
}
</style>
